import {
  useActivityLocationAutocomplete as useCoreActivityLocationAutocomplete,
  type ActivityLocationAutocompleteProps,
} from "@b2bportal/core-activities";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useActivityLocationAutocomplete = (
  props: ActivityLocationAutocompleteProps
) => {
  const { t } = useI18nContext();

  const coreReturnObj = useCoreActivityLocationAutocomplete(props);

  return {
    ...coreReturnObj,
    context: {
      ...coreReturnObj.context,
      placeholder: t("core-activities.search.locationPlaceholder"),
    },
  };
};
